var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSccWebsitePlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 895,
  height: 858,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#scc-website-placeholder_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 25c0-8.284 6.716-15 15-15h825c8.284 0 15 6.716 15 15v788c0 8.284-6.716 15-15 15H35c-8.284 0-15-6.716-15-15V25Z",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "scc-website-placeholder_svg__b",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 20,
  y: 10,
  width: 855,
  height: 818
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20 25c0-8.284 6.716-15 15-15h825c8.284 0 15 6.716 15 15v788c0 8.284-6.716 15-15 15H35c-8.284 0-15-6.716-15-15V25Z",
  fill: "#fff"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#scc-website-placeholder_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F7F8FC",
  d: "M50 90h795v350H50z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 80,
  y: 172,
  width: 260,
  height: 20,
  rx: 10,
  fill: "#E4E7EB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 80,
  y: 346,
  width: 150,
  height: 28,
  rx: 14,
  fill: "#DCDCDC"
}), /*#__PURE__*/React.createElement("rect", {
  x: 80,
  y: 199,
  width: 170,
  height: 20,
  rx: 10,
  fill: "#E4E7EB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 80,
  y: 249,
  width: 230,
  height: 8,
  rx: 4,
  fill: "#E4E7EB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 80,
  y: 281,
  width: 203,
  height: 8,
  rx: 4,
  fill: "#E4E7EB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 80,
  y: 265,
  width: 127,
  height: 8,
  rx: 4,
  fill: "#E4E7EB"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E4E7EB",
  strokeWidth: 2,
  d: "M51 765h253v348H51z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 100,
  y: 804,
  width: 155,
  height: 155,
  rx: 77.5,
  fill: "#DCDCDC"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E4E7EB",
  strokeWidth: 2,
  d: "M321 765h253v348H321z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 370,
  y: 804,
  width: 155,
  height: 155,
  rx: 77.5,
  fill: "#DCDCDC"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E4E7EB",
  strokeWidth: 2,
  d: "M591 765h253v348H591z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 640,
  y: 804,
  width: 155,
  height: 155,
  rx: 77.5,
  fill: "#DCDCDC"
}), /*#__PURE__*/React.createElement("path", {
  d: "m181 665 100-58 100 58H181Z",
  fill: "#E4E7EB"
}), /*#__PURE__*/React.createElement("path", {
  d: "m132 665 65.5-38 65.5 38H132Z",
  fill: "#E4E7EB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 337,
  y: 563,
  width: 44,
  height: 44,
  rx: 22,
  fill: "#E4E7EB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 555,
  y: 561,
  width: 260,
  height: 20,
  rx: 10,
  fill: "#E4E7EB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 556,
  y: 639,
  width: 148,
  height: 26,
  rx: 13,
  stroke: "#DCDCDC",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 555,
  y: 588,
  width: 170,
  height: 20,
  rx: 10,
  fill: "#E4E7EB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 50,
  y: 26,
  width: 150,
  height: 28,
  rx: 14,
  fill: "#E4E7EB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 355,
  y: 36,
  width: 40,
  height: 8,
  rx: 4,
  fill: "#A1A2B2"
}), /*#__PURE__*/React.createElement("rect", {
  x: 403,
  y: 38,
  width: 40,
  height: 4,
  rx: 2,
  fill: "#E4E7EB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 451,
  y: 38,
  width: 40,
  height: 4,
  rx: 2,
  fill: "#E4E7EB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 499,
  y: 38,
  width: 40,
  height: 4,
  rx: 2,
  fill: "#E4E7EB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 817,
  y: 26,
  width: 28,
  height: 28,
  rx: 14,
  fill: "#E4E7EB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 716,
  y: 27,
  width: 86,
  height: 26,
  rx: 13,
  stroke: "#E4E7EB",
  strokeWidth: 2
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "scc-website-placeholder_svg__a",
  x: 0,
  y: 0,
  width: 895,
  height: 858,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 10
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.0313725 0 0 0 0 0.4 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_5667:1325"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_5667:1325",
  result: "shape"
})))));
export { SvgSccWebsitePlaceholder as ReactComponent };
export default __webpack_public_path__ + "images/scc-website-placeholder.svg";